import React from 'react';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { RCAccordion, RCSelect } from '@reverbdotcom/cadence/components';
import { useUpdateUrl } from '@reverbdotcom/commons/src/components/with_update_url';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { withRouter, WithRouterProps } from 'react-router';

export function displayShipsToByDefault(facetGroup: SearchRemixer_FacetGroupFieldsFragment, shippingRegionCode?: string) {
  const selectedShipsToRegion = facetGroup?.facets.find(f => f.selected);
  return selectedShipsToRegion?.paramValue !== shippingRegionCode;
}

export interface RegionSelectFacetInnerProps {
  facetGroup: SearchRemixer_FacetGroupFieldsFragment;
  locationId?: string;
}

export function RegionSelectFacetInner({
  facetGroup,
  locationId = 'facet-group-row',
  router,
  location,
}: RegionSelectFacetInnerProps & WithRouterProps) {
  const user = useUser();
  const { updateUrl } = useUpdateUrl();
  const selectedShipsToRegion = facetGroup?.facets.find(f => f.selected);

  const handleClick = (event) => {
    if (event) { event.preventDefault(); }
    if (!event.target.value) return;

    const newUrl = updateUrl({
      location,
      newParams: { [facetGroup.key]: event.target.value },
    });
    router.push(newUrl);
  };

  return (
    <div className="facet">
      <RCSelect
        id={`${locationId}-${facetGroup.key}`}
        label={facetGroup.displayName}
        name={facetGroup.key}
        onChange={handleClick}
        value={selectedShipsToRegion.paramValue || user.shippingRegionCode}
      >
        {(facetGroup.facets).map((facet, idx) => (
          <RCSelect.Option
            key={`${locationId}-${facetGroup.key}-${facet.paramValue}-${idx}`}
            label={facet.displayName}
            value={facet.paramValue}
          />
        ))}
      </RCSelect>
    </div>
  );
}

export const RegionSelectFacet = withRouter(RegionSelectFacetInner);

export function SidebarRegionSelectFacet({ facetGroup }: { facetGroup: SearchRemixer_FacetGroupFieldsFragment }) {
  const user = useUser();
  const defaultOpen = displayShipsToByDefault(facetGroup, user.shippingRegionCode);
  return (
    <div className="facet facet--collapsible" data-testid={`nested-facet-group_${facetGroup.displayName}`}>
      <RCAccordion
        id={facetGroup.key}
        heading={facetGroup.displayName}
        defaultOpen={defaultOpen}
      >
        <RegionSelectFacet facetGroup={facetGroup} locationId="sidebar" />
      </RCAccordion>
    </div>
  );
}
